import { getUserMailboxInfo } from 'owa-client-ids';
import { getGroupMailboxInfo, getGroupIdFromTableQuery } from 'owa-group-common';
import { getPublicFolderMailboxInfo } from 'owa-publicfolder-utils';
import { isPublicFolder } from 'owa-folders';
import fetchUserMailboxInfoFromFolderId from './helpers/fetchUserMailboxInfoFromFolderId';
export default function getMailboxInfo(tableView) {
    if (tableView) {
        return getMailboxInfoFromTableQuery(tableView.tableQuery);
    }
    return getUserMailboxInfo();
}
export function getMailboxInfoFromTableQuery(tableQuery) {
    var groupId = getGroupIdFromTableQuery(tableQuery);
    var folderId = tableQuery && tableQuery.folderId;
    return groupId != null ? getGroupMailboxInfo(groupId) : getMailboxInfoFromFolderId(folderId);
}
export function getMailboxInfoFromFolderId(folderId) {
    if (isPublicFolder(folderId)) {
        return getPublicFolderMailboxInfo(folderId);
    }
    else {
        return fetchUserMailboxInfoFromFolderId(folderId);
    }
}
//# sourceMappingURL=getMailboxInfo.js.map